import { render, staticRenderFns } from "./CategoryAdvertsCount.vue?vue&type=template&id=5b65a56d&scoped=true&lang=pug&"
import script from "./CategoryAdvertsCount.vue?vue&type=script&lang=js&"
export * from "./CategoryAdvertsCount.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdvertsCount.vue?vue&type=style&index=0&id=5b65a56d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65a56d",
  null
  
)

export default component.exports